export default {
  setCandidates(state, value) {
    state.candidates = value
  },
  setCandidate(state, value) {
    state.candidate = value
  },
  setCandidatesFilters(state, value) {
    state.candidatesFilters = value
  },
  setCandidatesRulesArray(state, arrayRules) {
    state.candidatesRules = arrayRules.slice()
  },
  setCandidatesRule(state, obj) {
    state.candidatesRules.push(obj)
  },
  deleteCandidatesRule(state, obj) {
    _.each(state.candidatesRules, (item, idx) => {
      // TODO REfactor - item undefined in array
      if (item != undefined) {
        if (item.tag === obj.tag) {
          state.candidatesRules.splice(idx, 1)
          return
        }
      }
    })
  },
}
